module.exports = __webpack_public_path__ + "img/Avatar.35627c16.png";